import { Box, styled } from '@mui/material'
import { FC, MouseEvent, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const StatusRoot = styled(Box)`
  flex: none;
`

const ResetButton = styled('button')`
  appearance: none;
  background: transparent;
  border: none;
  color: #ffbf36;
  font-size: 12px;
  margin-right: 4px;
  padding: 0;
  vertical-align: middle;
  cursor: pointer;
`

const CountBadge = styled('span')`
  font-size: 10px;
  font-weight: 700;

  background-color: #ffbf36;
  color: #000000;
  vertical-align: middle;

  display: inline-block;
  text-align: center;
  width: 18px;
  height: 18px;
  line-height: 18px;
  border-radius: 99px;
`

const ResetFilter: FC<Props> = (props: Props) => {
  const { className, filterCount, onReset } = props

  const { t } = useTranslation()

  const onResetClick = useCallback(
    (e: MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      onReset()
    },
    [onReset]
  )

  if (filterCount === 0) {
    return null
  }

  return (
    <StatusRoot className={className}>
      <ResetButton type='button' onClick={onResetClick}>
        {t('filter.reset_all_setting')}
      </ResetButton>
      <CountBadge>{filterCount}</CountBadge>
    </StatusRoot>
  )
}

type Props = {
  className?: string
  filterCount: number
  onReset: () => void
}

export default ResetFilter
